"use strict";

exports.__esModule = true;
exports.CalendarContext = void 0;
var _CalendarController = require("../CalendarController");
var _Utils = require("../../../Utils");
/**
 * Provides the plant calendar to consumers.
 * @component
 */
var CalendarContext = exports.CalendarContext = (0, _Utils.createEnhancedContext)({
  propName: "calendar",
  defaultController: _CalendarController.CalendarController
});